import ConfirmDialog from "../../../components/customHelpers/ConfirmDialog";
import Controls from "../../../components/controls/Controls";
import Norecords from "../../../components/customHelpers/Norecords";
import Loading from "../../../components/customHelpers/Loading";
import Layout from "../../../components/layout/Layout";
import {
  Grid,
  Box,
  TableCell,
  TableRow,
  TableBody,
  Typography,
} from "@mui/material";

import { makeStyles } from "@mui/styles";

import { useEffect, useState } from "react";
import { MdOutlineDelete } from "react-icons/md";
import { IoMdAdd } from "react-icons/io";
import useTable from "../../../components/customHelpers/usePaginationTable";
import Notify from "../../../components/customHelpers/Notify";
import Notification from "../../../components/customHelpers/Notification";
import { MdAssignmentInd } from "react-icons/md";
import Admin from "../../../components/auth/Admin";
import Order from "../../../actions/order";
import UpdateOrder from "../../../components/forms/addOrders";
import Popup from "../../../components/customHelpers/Popup";
import produce from "immer";
import { FiEdit, FiEye } from "react-icons/fi";
import { useHistory } from "react-router-dom";
import Assigntff from "./assignToUser";
import { isAuth } from "../../../actions/auth";
import ClearAllIcon from "@mui/icons-material/ClearAll";
import InfoComponent from "../../../components/InfoComponent";
import Customer from "../../../actions/customer";
import { statusBadge } from "../../../components/statusBadge";
import {
  Paper,
  Autocomplete,
  TextField,
  MenuItem,
  Button,
  Select,
  Pagination,
  Tabs,
  Tab,
  FormControl,
  InputLabel,
  Select as MuiSelect,
} from "@mui/material";
import OrderAssignConfirmDialog from "../../../components/customHelpers/OrderAssignDialog";
import { formatNumber, pageSizes } from "../../../utils/utils";
import { Search } from "@mui/icons-material";
const headCells = [
  { id: "id", label: "Id" },
  { id: "customer", label: "Customer" },
  { id: "assignTo", label: "Assigned To" },
  { id: "quantity", label: "Item Count" },
  { id: "totalPrice", label: "Total Price" },
  { id: "paid", label: "Paid" },
  { id: "unpaid", label: "Balance" },
  { id: "createdAt", label: "Date" },
  { id: "status", label: "Status" },
  { id: "actions", label: "Actions", disableSorting: true },
];

const statusTabs = [
  { label: "All", value: null },
  { label: "Ordered", value: "ORDERED" },
  { label: "Pending", value: "PENDING" },
  { label: "Ready for Shipment", value: "Ready for Shipment" },
  { label: "Shipped", value: "Shipped" },
];

const radioOptions = [
  { label: "My Created Order", value: "myCreatedOrder" },
  { label: "My Assigned Order", value: "myAssignedOrder" },
  { label: "All", value: "all" },
];

const OrderPage = () => {
  const history = useHistory();
  const { NotifyMessage, notify, setNotify } = Notify();
  const { viewAllOrdersWithPages, deleteMainOrder } = Order();
  const [recordForEdit] = useState(null);
  const [openPopup, setOpenPopup] = useState(false);
  const [openPopupAssign, setOpenPopupAssign] = useState(false);

  const [edit] = useState(false);
  const [id, setId] = useState(null);
  const [orders, setOrders] = useState([]);
  const [filteredOrders, setFilteredOrders] = useState([]);
  const [temp, setTemp] = useState([]);

  const [customers, setCustomers] = useState([]);
  const { viewAllCustomers } = Customer();
  const [selectedStatus, setSelectedStatus] = useState(null);
  const [selectedCustomer, setSelectedCustomer] = useState(null);
  const [page, setPage] = useState(1);
  const [tot, setTot] = useState(1);
  const [limit, setLimit] = useState(pageSizes[1]);
  const [totalPages, setTotalPages] = useState(1);
  const [searchQuery, setSearchQuery] = useState("");
  const [actualTotal, setActualTotal] = useState();
  const [type, setType] = useState(null);
  const [values, setValues] = useState({
    loading: false,
    reload: false,
  });
  const { loading, reload } = values;

  useEffect(() => {
    getAllOrders();
  }, [
    reload,
    page,
    limit,
    searchQuery,
    selectedCustomer,
    selectedStatus,
    type,
  ]);

  useEffect(() => {
    getAllCustomers();
  }, []);
  const [confirmDialog, setConfirmDialog] = useState({
    isOpen: false,
    title: "",
    subTitle: "",
  });

  const [additionalConfirmDialog, setAdditionalConfirmDialog] = useState({
    isOpen: false,
    title: "",
    subTitle: "",
    onConfirm: () => {},
  });

  const [filterFn, setFilterFn] = useState({
    fn: (items) => {
      return items;
    },
  });
  const getAllCustomers = () => {
    setValues({ ...values, loading: true });
    viewAllCustomers().then((data) => {
      if (data.err) {
        NotifyMessage({
          message: data.err,
          type: "error",
        });
      } else if (data.customers) {
        setValues({
          ...values,
          loading: false,
        });
        setCustomers(data.customers);
      }
    });
  };

  const getAllOrders = () => {
    setValues({ ...values, loading: true });
    viewAllOrdersWithPages(
      page,
      limit,
      searchQuery,
      selectedCustomer?.fullName,
      selectedStatus,
      null,
      null,
      null,
      type
    ).then((data) => {
      if (data.err) {
        NotifyMessage({
          message: data.err,
          type: "error",
        });
      } else if (data.orders) {
        setValues({
          ...values,
          loading: false,
        });
        const modifiedOrders = data.orders.map((order) => ({
          ...order,
          customer: order?.customer?.fullName,
          cusomerId: order?.customer?.id,
        }));
        setOrders(modifiedOrders);
        setFilteredOrders(modifiedOrders);
        setTemp(modifiedOrders);
        setCheckedItems("all");
        setTotalPages(Math.ceil(data.total / limit));
        setActualTotal(data.pagination.total);
        setTot(data.pagination.totalPages);
      }
    });
  };

  const onDelete = (Id) => {
    setConfirmDialog({
      ...confirmDialog,
      isOpen: false,
    });
    setValues({ ...values, loading: true });

    deleteMainOrder(Id).then((data) => {
      if (data.err) {
        NotifyMessage({
          message: data.err,
          type: "error",
        });
        if (
          data.err ===
          "Not assigned for you, please assign to yourself first to continue"
        ) {
          getAllOrders();
        }
        setValues({ ...values, loading: false });
      } else {
        NotifyMessage({
          message: data.message,
          type: "success",
        });
        setValues({ ...values, loading: false });
        setOrders(
          produce(orders, (draft) => {
            const index = orders.findIndex((item) => item.id === Id);
            if (index !== -1) draft.splice(index, 1);
          })
        );
      }
    });
  };

  const {
    TblContainer,
    TblHead,
    TblPagination,
    recordsAfterSortingAndFiltering,
  } = useTable(orders, headCells, filterFn);

  const handleSearch = (e) => {
    setPage(1);
    setSearchQuery(e.target.value);
  };

  const calculateTotalPrice = (data) => {
    let totalPrice = 0;
    if (data.length > 0) {
      data.forEach((order) => {
        totalPrice += parseFloat(order.totalPrice);
      });
      return totalPrice.toFixed(2);
    }
  };

  const [checkedItems, setCheckedItems] = useState("all");

  const handleTypeChange = (event, newType) => {
    if (newType !== null) {
      setPage(1);
      setType(newType === "all" ? null : newType);
    }
  };

  const [orderConfirmDialog, setOrderConfirmDialog] = useState({
    isOpen: false,
    title: "",
    subTitle: "",
  });

  const handleStatusTabChange = (event, newValue) => {
    setPage(1);
    setSelectedStatus(statusTabs[newValue].value);
  };

  const statusTabIndex = statusTabs.findIndex(
    (tab) => tab.value === selectedStatus
  );

  const handleCustomerChange = (value) => {
    setPage(1);
    setSelectedCustomer(
      value ? { id: value.id, fullName: value.fullName } : null
    );
    setSearchQuery("");
  };
  const clearFilters = () => {
    setSelectedCustomer(null);
    setSelectedStatus(null);
    setPage(1);
    setLimit(25);
  };

  const handlePageChange = (event, newPage) => {
    setPage(newPage);
  };

  const handlePageSizeChange = (event) => {
    setLimit(event.target.value);
    setPage(1);
  };
  const startIndex = (page - 1) * limit + 1;
  const endIndex = Math.min(startIndex + limit - 1, actualTotal);

  return (
    <Layout>
      <Admin>
        <div className="card">
          <Box
            display="flex"
            alignItems="center"
            justifyContent="space-between"
          >
            <Typography variant="h6" className="page-header">
              Orders
            </Typography>
            <Controls.Button
              text="Add Order"
              variant="outlined"
              startIcon={<IoMdAdd />}
              className="newButton"
              onClick={() => {
                history.push(`/order`);
              }}
            />
          </Box>

          <InfoComponent pageKey="orders" />

          <Box sx={{}}>
            <Tabs
              value={statusTabIndex === -1 ? 0 : statusTabIndex}
              onChange={handleStatusTabChange}
              aria-label="Order Status Tabs"
              variant="scrollable"
              scrollButtons="auto"
              textColor="primary"
              indicatorColor="primary"
            >
              {statusTabs.map((tab) => (
                <Tab key={tab.label} label={tab.label} />
              ))}
            </Tabs>
          </Box>

          <Box
            display="flex"
            alignItems="center"
            justifyContent="space-between"
            gap={2}
            flexWrap="wrap"
          >
            <div
              className="search-header-container"
              style={{ marginBottom: 0, flex: 1, maxWidth: 260, minWidth: 260 }}
            >
              <div className="search-header-flex">
                <div className="search-container">
                  <Search className="search_icon" />
                  <input
                    type="text"
                    onChange={handleSearch}
                    placeholder="Search Product"
                    className="search-input"
                    style={{ width: "100%" }}
                  />
                </div>
              </div>
            </div>

            <Box display="flex" marginBottom={4} alignItems="flex-end" gap={2}>
              <Autocomplete
                options={customers}
                value={selectedCustomer}
                disableClearable
                getOptionLabel={(option) => `${option.fullName}`}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    label="Select Customer"
                    variant="outlined"
                    InputProps={{
                      ...params.InputProps,
                      type: "search",
                    }}
                  />
                )}
                onChange={(event, value) => handleCustomerChange(value)}
              />

              <FormControl
                size="small"
                sx={{
                  minWidth: 120,
                  maxWidth: 150,
                  borderRadius: 1,
                  height: 30,
                }}
              >
                <InputLabel
                  id="order-type-select-label"
                  sx={{
                    fontSize: "0.67rem",
                    top: "-7px",
                    color: "#374151",
                  }}
                >
                  Order Type
                </InputLabel>
                <MuiSelect
                  labelId="order-type-select-label"
                  id="order-type-select"
                  value={type === null ? "all" : type}
                  label="Order Type"
                  onChange={(e) => {
                    const value = e.target.value;
                    setPage(1);
                    setType(value === "all" ? null : value);
                  }}
                  sx={{
                    "& .MuiSelect-select": {
                      fontSize: "0.76rem",
                      padding: "0.5rem 0.75rem 0.5rem 0.75rem",
                      color: "#374151",
                      backgroundColor: "#ffffff",
                      border: "1px solid #d1d5db",
                      borderRadius: "0.5rem",
                      boxShadow: "0 1px 2px 0 rgba(0, 0, 0, 0.05)",
                      minHeight: "auto",
                      height: "30px",
                      display: "flex",
                      alignItems: "center",
                    },
                    "& .MuiOutlinedInput-notchedOutline": {
                      border: "none",
                    },
                    "&:hover .MuiOutlinedInput-notchedOutline": {
                      border: "none",
                    },
                    "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
                      border: "none",
                      boxShadow: "0 0 0 3px rgba(59, 130, 246, 0.2)",
                    },
                    "& .MuiSelect-icon": {
                      color: "#374151",
                    },
                  }}
                >
                  {radioOptions.map((option) => (
                    <MenuItem
                      key={option.value}
                      value={option.value}
                      sx={{
                        fontSize: { xs: "0.7rem", sm: "0.875rem" },
                        whiteSpace: "normal",
                        overflow: "hidden",
                        textOverflow: "ellipsis",
                        maxWidth: "100%",
                      }}
                    >
                      {option.label}
                    </MenuItem>
                  ))}
                </MuiSelect>
              </FormControl>
              {(selectedCustomer || selectedStatus) && (
                <Button
                  variant="contained"
                  onClick={clearFilters}
                  endIcon={<ClearAllIcon />}
                  sx={{
                    padding: "2px 6px",
                    fontSize: "0.75rem",
                    width: "100px",
                    height: "32px",
                    minHeight: "32px",
                    backgroundColor: "rgba(244,151,3,.8)",
                    color: "rgb(20,61,89)",
                    "&:hover": {
                      backgroundColor: "rgba(244,151,3,.8)",
                      color: "rgb(20,61,89)",
                    },
                  }}
                >
                  Clear
                </Button>
              )}
            </Box>
          </Box>

          <Grid container>
            <Grid item xs={12} className="card__body">
              {loading ? (
                <Loading />
              ) : (
                <Paper style={{ overflowX: "auto" }}>
                  <TblContainer className="page-table order-page-table">
                    <TblHead />
                    <TableBody className="page-table-body">
                      {recordsAfterSortingAndFiltering().length > 0 ? (
                        recordsAfterSortingAndFiltering().map((item) => (
                          <TableRow key={item.id}>
                            <TableCell className="page-table-cell">
                              {item.orderId
                                ? item.orderId
                                : `${item.id.slice(0, 7)}--`}
                            </TableCell>
                            <TableCell className="page-table-cell">
                              <div className="page-customer-name">
                                {item.customer}
                              </div>
                            </TableCell>
                            <TableCell className="page-table-cell hidden lg:table-cell">
                              <div className="page-assigned-to">
                                {item.staff?.fullName}
                              </div>
                            </TableCell>
                            <TableCell className="page-table-cell hidden xl:table-cell">
                              <div className="page-item-count">
                                <span className="page-item-badge">
                                  {item?.orderProducts?.length || 0}
                                </span>
                              </div>
                            </TableCell>
                            <TableCell className="page-table-cell">
                              <div className="page-total">
                                {item?.orderProducts?.length > 0
                                  ? formatNumber(
                                      calculateTotalPrice(item.orderProducts)
                                    )
                                  : 0}
                              </div>
                            </TableCell>
                            <TableCell className="page-table-cell hidden sm:table-cell">
                              <div className="page-paid">
                                {formatNumber(item.paid || 0)}
                              </div>
                            </TableCell>
                            <TableCell className="page-table-cell hidden sm:table-cell">
                              <div
                                className={`page-balance ${
                                  parseFloat(
                                    (
                                      Number(
                                        calculateTotalPrice(
                                          item.orderProducts
                                        ) || 0
                                      ) - Number(item.paid || 0)
                                    ).toString()
                                  ) < 0
                                    ? "text-red-600"
                                    : parseFloat(
                                        (
                                          Number(
                                            calculateTotalPrice(
                                              item.orderProducts
                                            ) || 0
                                          ) - Number(item.paid || 0)
                                        ).toString()
                                      ) > 0
                                    ? "text-amber-600"
                                    : "text-emerald-600"
                                }`}
                              >
                                {formatNumber(
                                  Number(
                                    calculateTotalPrice(item.orderProducts) || 0
                                  ) - Number(item.paid || 0)
                                )}
                              </div>
                            </TableCell>
                            <TableCell className="page-table-cell">
                              {new Date(item.createdAt).toLocaleString()}
                            </TableCell>
                            <TableCell className="page-table-cell">
                              {statusBadge(item.status || "Unknown")}
                            </TableCell>
                            <TableCell className="page-table-cell">
                              <div
                                style={{
                                  display: "flex",
                                  gap: "5px",
                                  flexWrap: "nowrap",
                                }}
                              >
                                {item.status !== "Shipped" &&
                                  item.status !== "Ready for Shipment" &&
                                  isAuth()?.id === item?.assignTo && (
                                    <Controls.ActionButton
                                      color="secondary"
                                      title="Delete"
                                      onClick={() => {
                                        setConfirmDialog({
                                          isOpen: true,
                                          title:
                                            "Are you sure to delete this Order?",
                                          subTitle:
                                            "You can't undo this operation",
                                          onConfirm: () => {
                                            onDelete(item.id);
                                          },
                                        });
                                      }}
                                    >
                                      <MdOutlineDelete fontSize="medium" />
                                    </Controls.ActionButton>
                                  )}
                                {item.status !== "Shipped" &&
                                  item.status !== "Ready for Shipment" &&
                                  isAuth()?.id === item?.assignTo && (
                                    <Controls.ActionButton
                                      color="primary"
                                      title="Update"
                                      onClick={() => {
                                        history.push(
                                          `/orderDetail/${
                                            item.orderId
                                              ? item.orderId
                                              : item.id
                                          }`
                                        );
                                      }}
                                    >
                                      <FiEdit fontSize="medium" />
                                    </Controls.ActionButton>
                                  )}
                                <Controls.ActionButton
                                  color="primary"
                                  title="View Detail"
                                  onClick={() => {
                                    history.push(
                                      `/print/${
                                        item.orderId ? item.orderId : item.id
                                      }`
                                    );
                                  }}
                                >
                                  <FiEye fontSize="medium" />
                                </Controls.ActionButton>
                                <Controls.ActionButton
                                  color="primary"
                                  title="Assign"
                                  onClick={() => {
                                    setOpenPopupAssign(true);
                                    setId(item.id);
                                  }}
                                >
                                  <MdAssignmentInd fontSize="medium" />
                                </Controls.ActionButton>
                              </div>
                            </TableCell>
                          </TableRow>
                        ))
                      ) : (
                        <Norecords col={6} />
                      )}
                    </TableBody>
                  </TblContainer>
                  <Box
                    sx={{
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "flex-end",
                      p: 2,
                      backgroundColor: "background.paper",
                      borderTop: 1,
                      borderColor: "divider",
                      gap: 2,
                    }}
                  >
                    <Box sx={{ display: "flex", alignItems: "center", mr: 2 }}>
                      <Typography variant="body2" sx={{ mr: 1 }}>
                        Rows per page:
                      </Typography>
                      <Select
                        value={limit}
                        onChange={handlePageSizeChange}
                        size="small"
                        sx={{ minWidth: 120 }}
                      >
                        {pageSizes.map((size) => (
                          <MenuItem key={size} value={size}>
                            {size}
                          </MenuItem>
                        ))}
                      </Select>
                    </Box>
                    {actualTotal && (
                      <span>
                        {" "}
                        {startIndex}-{endIndex} of {actualTotal}
                      </span>
                    )}
                    {orders.length > 0 && (
                      <Pagination
                        count={totalPages}
                        page={page}
                        onChange={handlePageChange}
                        color="primary"
                        hideNextButton={page === tot || orders.length === 0}
                        hidePrevButton={page === 1}
                        shape="rounded"
                        siblingCount={1}
                        disabled={orders.length === 0}
                      />
                    )}
                  </Box>{" "}
                </Paper>
              )}
            </Grid>
          </Grid>
          <ConfirmDialog
            confirmDialog={confirmDialog}
            setConfirmDialog={setConfirmDialog}
          />
          <ConfirmDialog
            confirmDialog={additionalConfirmDialog}
            setConfirmDialog={setAdditionalConfirmDialog}
          />
          <OrderAssignConfirmDialog
            confirmDialog={orderConfirmDialog}
            setConfirmDialog={setOrderConfirmDialog}
          />
          <Notification notify={notify} setNotify={setNotify} />
        </div>
        <Popup
          title="Order Form"
          openPopup={openPopup}
          setOpenPopup={setOpenPopup}
        >
          <UpdateOrder
            NotifyMessage={NotifyMessage}
            setOpenPopup={setOpenPopup}
            recordForEdit={recordForEdit}
            setOrders={setOrders}
            getAllOrders={getAllOrders}
            edit={edit}
          />
        </Popup>
        <Popup
          title="Assign User"
          openPopup={openPopupAssign}
          setOpenPopup={setOpenPopupAssign}
        >
          <Assigntff
            NotifyMessage={NotifyMessage}
            setOpenPopup={setOpenPopupAssign}
            recordForEdit={recordForEdit}
            setOrders={setOrders}
            getAllOrders={getAllOrders}
            edit={edit}
            handleStatusChange={null}
            event={null}
            id={id}
          />
        </Popup>
      </Admin>
    </Layout>
  );
};

export default OrderPage;
